import React, { Suspense } from 'react';
import { Spinner } from 'reactstrap';

/**
 * HrEmbeddedPage — Round: HR UI Simplification (Phase 1).
 *
 * Renders one of the EXISTING standalone HR pages inside the canonical
 * HR shell. Two jobs only:
 *
 *  1. `.hr-embedded` scope — hr-shell.css neutralizes the page's own
 *     `.page-content` padding, its gradient banner, and any duplicate
 *     ToastContainer, so the shell shows exactly one compact header and
 *     one toast host. The page component itself is byte-for-byte the
 *     one the old deep route rendered: same fetches, same payloads,
 *     same permissions, same buttons.
 *
 *  2. Local Suspense boundary — every embedded page is code-split with
 *     React.lazy in the section files, so Reports code isn't downloaded
 *     until a report is picked (performance rule: don't mount hidden
 *     tabs, don't load report components until selected). The fallback
 *     is a small local spinner — never a full-screen overlay.
 */
const HrEmbeddedPage = ({ children }) => (
    <div className="hr-embedded">
        <Suspense
            fallback={
                <div className="d-flex align-items-center gap-2 text-muted py-4" role="status" aria-live="polite">
                    <Spinner size="sm" /> Loading…
                </div>
            }
        >
            {children}
        </Suspense>
    </div>
);

export default HrEmbeddedPage;
